import script from "./LocationSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationSection.vue?vue&type=script&setup=true&lang=js"

import "./LocationSection.vue?vue&type=style&index=0&id=70d397ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d397ba"]])

export default __exports__